//  Application imports
import { Utils } from 'app/utils';
//  Third party imports
import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';

/* eslint-disable  @typescript-eslint/no-unused-vars */

export abstract class RMenuItem {
    @deserialize
    public description: string;
    @deserialize
    public displayName: string;
    @deserialize
    public order: number;
    @deserialize
    public url: string;
    @deserialize
    public visibility: 'ShowEnabled' | 'ShowDisabled' | undefined;
}

@inheritSerialization(RMenuItem)
export class RSubMenuItem extends RMenuItem {
    @deserialize
    public imageContent: string;
    @deserialize
    public itemId: number;
    @deserialize
    public sectionHeader: string;
}

@inheritSerialization(RMenuItem)
export class RMainMenuItem extends RMenuItem {

    public static OnDeserialized(instance: RMainMenuItem, _: unknown): void {
        if (instance.items) {
            instance.items.sort(Utils.sortByOrder);
        }
    }

    @deserializeAs(RSubMenuItem)
    public items?: Array<RSubMenuItem>;

    // for simplicity checks

    public get hasItems(): boolean {
        if (this.items === null || this.items.length <= 0) {
            return false;
        }

        return true
    }

}
